var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let properties = options.buildingData.properties,
       srpUrl = options.buildingData.srp_url,
       is_single_unit = false; 
__p+='\n\n';
 if (properties) { 
__p+='\n  <h2 class="title-section">\n    <i class="ra ra-similar-homes"></i>Other homes in the building\n  </h2>\n  ';
 if(properties.length == 1) { 
__p+='\n    <div class="single-unit-browse-module">\n      '+
((__t=( JST["quick_view/templates/building-unit/browse-module-card"]({property: properties[0], listing_index: 0, is_single_unit: true}) ))==null?'':__t)+
'\n      ';
 if(properties[0].description){ 
__p+='\n        ';
 let propertyDescription = $("<div/>").html(properties[0].description.replace(/ +(?= )/g,'')).text(); 
__p+='\n        <div class="single-browse-module-content hidden-xs hidden-xxs col-sm-6">\n          <h1 class= "single-browse-module-title"> From the Agent </h1>\n          <blockquote class="single-browse-module-description">'+
((__t=( propertyDescription ))==null?'':__t)+
'</blockquote>\n          <a class="single-browse-module-more pull-right" href= "'+
((__t=( properties[0].ldp_url ))==null?'':__t)+
'" data-omtag="ldp:oth-bldng-units:for-sale:units:single-card"> See more </a>\n        </div>\n      ';
 } 
__p+='\n    </div>\n  ';
 } else { 
__p+='\n    <div class="component_bm-carousel">\n      <div class="rdc-carousel">\n        <div class="owl-carousel">\n          ';
 properties.forEach((property, listing_index) => { 
__p+='\n            '+
((__t=( JST["quick_view/templates/building-unit/browse-module-card"]({property, listing_index, is_single_unit}) ))==null?'':__t)+
'\n          ';
 }) 
__p+='\n          ';
 if(srpUrl){ 
__p+='\n            <div class="compact-card-image-wrapper listing-card-compact browse-module-card bm-view-more-card">\n              <a href="'+
((__t=(srpUrl))==null?'':__t)+
'" data-omtag="ldp:oth-bldng-units:for-sale:see-more:card"></a>\n            </div>\n          ';
 } 
__p+='\n        </div>\n        <div class="rdc-carousel-nav">\n          <div class="rdc-prev-set hide"><i class="ra ra-angle-left"></i></div>\n          <div class="rdc-next-set hide"><i class="ra ra-angle-right"></i></div>\n        </div>\n      </div>\n    </div>\n  ';
 } 
__p+='\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/building-unit/building-units-carousel.jst.ejs